<template>
  <v-row no-gutters>
    <v-col
      class="d-flex align-center bg-lightprimary"
      cols="12">
      <v-container>
        <div class="pa-sm-12">
          <v-row justify="center">
            <v-col
              cols="12"
              lg="10"
              md="7"
              xl="6">
              <v-card>
                <v-card variant="outlined">
                  <v-card-text class="pa-6">
                    <v-row>
                      <v-col
                        class="text-center"
                        cols="12">
                        <h4 class="text-secondary text-h4 mt-3">Bitte loggen Sie sich ein, um weitere Funktionen zu nutzen.</h4>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col
                        class="text-center"
                        cols="12">
                        <v-btn
                          color="primary"
                          variant="outlined"
                          @click="handleLogin">
                          <BrandWindowsIcon />
                          <span class="ml-2"> Login<span class="d-none d-sm-inline"> mit Microsoft</span> </span>
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-row v-if="$authStore.loginError">
                      <v-col cols="12">
                        <v-alert
                          closable
                          data-testid="login-error"
                          type="error"
                          variant="tonal"
                          @click:close="$authStore.setLoginError(null)">
                          {{ $authStore.loginError }}
                        </v-alert>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-col>
  </v-row>
</template>

<script lang="ts" setup>
import { msalService } from '@/config/useAuth.ts';
import { useAuthStore } from '@/stores/auth.ts';
import { BrandWindowsIcon } from 'vue-tabler-icons';

const { login } = msalService();
const $authStore = useAuthStore();

const handleLogin = async () => {
  $authStore.setLoginError(null);
  await login();
};
</script>
